import { RangeSlider } from "@pjs/core-ui";
import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";

angularAMD.component("rangeSlider", react2angular(RangeSlider, ["progressColour", "ticks", "value", "thumbHeight", "thumbWidth", "step", "min", "max", "disabled", "onChange"]));
